<template>
    <div>
        <div class="page-background">
            <div class="page-content mx-auto relative h-screen">
                <div class="h-full flex flex-wrap content-center">
                    <img src="../assets/icon/ic-mepoint-coming-soon.png"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created: function() {
        document.title = "mePoint";
    }
}
</script>

<style lang="scss" scoped>
    .page-background {
        background-image: url(../assets/bg/bg-mepoint.svg);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }
    .page-content {
        max-width: 414px;
        margin: 0 auto;
    }
</style>
